<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="编辑管理员"
      center
      width="600px"
      :before-close="$onClose"
      :destroy-on-close="false"
      @close="close()"
    >
      <div>
        <div>
          <h4 class="title">管理员姓名</h4>
          <el-input v-model="name" placeholder="请输入"></el-input>
        </div>
        <div>
          <h4 class="title">所属角色</h4>
          <el-select class="input" v-model="power" placeholder="请选择">
            <el-option
              v-for="item in powerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div>
          <h4 class="title">状态</h4>
          <el-select v-model="status" placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";
import * as StrUtils from "@/utils/strUtils.js";

export default {
  data() {
    return {
      changVisible: false,

      role_list: [],
      powerOptions: [],
      admin_id: "",
      name: "",
      power: "",
      status: "",

      statusOptions: Constant.admin_status_options, //状态
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
      this.role_list = [];
      this.powerOptions = [];
      this.name = "";
      this.power = "";
      this.status = "";
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;
      if (
        StrUtils.isEmpty(this.name) ||
        StrUtils.isEmpty(this.status) ||
        StrUtils.isEmpty(this.power)
      ) {
        this.$message.error("请完善信息");
        return;
      }
      this.updateAdminUser();
    },
    //页面初始化时加载的事件
    show(info) {
      this.admin_id = info.id;
      this.name = info.name;
      this.status = info.status;
      this.power = info.power;
      this.changVisible = true;
      this.powerTemplateList();
    },
    // 获取角色列表
    powerTemplateList: function () {
      this.$api
        .powerTemplateList({
          token: localStorage.getItem("token"),
        })
        .then(({ data }) => {
          this.role_list = data.Data;
          this.role_list.forEach((role) => {
            this.powerOptions.push({
              value: role.id,
              label: role.template_cn,
            });
          });
        })
        .catch(({ error }) => {});
    },
    // 管理员编辑
    updateAdminUser() {
      this.$api
        .updateAdminUser({
          token: localStorage.getItem("token"),
          admin_id: this.admin_id,
          name: this.name,
          status: this.status,
          power: this.power,
        })
        .then(({ data }) => {
          this.$emit("toSave");
          this.close();
        })
        .catch(({ error }) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/adminUpdateDialog.vue